import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import TagsState from '../../types/TagsState'
import Tag from '../../types/Tag'

const mutations: MutationTree<TagsState> = {
  [types.SET_PARTNER_TAGS] (state, payload: Tag[]) {
    state.tags = payload
  },
  [types.TOGGLE_PARTNER_TAG] (state, payload: Tag) {
    // let idx = state.selected_tags.indexOf(payload)

    let isActiveTags = state.selected_tags.length && state.selected_tags.find(tag => tag.entity_id === payload.entity_id && tag.code === payload.code)
    /*if (idx == -1) {
      state.selected_tags.push(payload)
    } else {
      state.selected_tags.splice(idx, 1)
    }*/

    if (!isActiveTags) {
      state.selected_tags = [payload]
    } else {
      state.selected_tags = []
    }
  },
  [types.CLEAN_SELECTED_TAGS] (state) {
    state.selected_tags = []
  },
  [types.SET_TAGS_LOADED_FOR] (state, payload: string | null) {
    state.loadedFor = payload
  }
}

export default mutations
